import { SplunkSearch, SplunkSavedSearch } from '@splunk/datasources';
import { EnterpriseTimeRangeInput } from '@splunk/dashboard-inputs';
import {
    withRiskySearchToast,
    mapWithRiskySearchToast,
} from '@splunk/dashboard-ui';
import type { PresetMap } from '@splunk/dashboard-types';
import CloudPreset from './CloudPreset';
import {
    withShowCornerRadiusEditor,
    withResizeHandles,
    withHideInViewMode,
} from './utils';

export default {
    ...CloudPreset,
    inputs: {
        ...CloudPreset.inputs,
        'input.timerange': withHideInViewMode(
            withResizeHandles(
                withShowCornerRadiusEditor(EnterpriseTimeRangeInput),
                ['w', 'e']
            )
        ),
        'input.dropdown': withRiskySearchToast(
            CloudPreset.inputs['input.dropdown']
        ),
        'input.multiselect': withRiskySearchToast(
            CloudPreset.inputs['input.multiselect']
        ),
    },
    dataSources: {
        ...CloudPreset.dataSources,
        'ds.search': SplunkSearch,
        'ds.savedSearch': SplunkSavedSearch,
        'ds.chain': SplunkSearch,
    },
    visualizations: mapWithRiskySearchToast(CloudPreset.visualizations),
} as PresetMap;
